/* Kyaro goodiebag V6 fx: the postmark lands on the postage stamp. CSS owns keyframes; this only times gb-fx-go.
   Beat: stamp in view + fonts + load + 800 ms pause (hard cap ~2 s). Deadline < CSS safety reveal (3.2 s). */
(function (w, d) {
  'use strict';
  var G = w.KyaroGB = w.KyaroGB || {}, h = d.documentElement, c = h.classList,
    s = d.querySelector('[data-gb-stamp]'), T = [], io, dn, P, B, V, L, n, cap;
  if (G.fx) return;
  G.fx = 1;
  if (!c.contains('gb-fx')) return;
  function end() {
    if (dn) return;
    dn = 1;
    if (io) io.disconnect();
    while (T.length) clearTimeout(T.pop());
    clearTimeout(L);
    c.remove('gb-fx');
    c.remove('gb-fx-go');
  }
  function go() {
    if (P || dn || !B || !V) return;
    P = 1;
    io.disconnect();
    clearTimeout(L);
    try { w.sessionStorage.gbfx = '1'; } catch (e) {}
    var k = s.querySelector('[data-gb-ink]');
    if (k) k.addEventListener('animationend', end);
    T.push(setTimeout(end, 1000));
    c.add('gb-fx-go');
  }
  function beat() { B = 1; go(); }
  function ld() { T.push(setTimeout(beat, 800)); }
  function st() { d.readyState === 'complete' ? ld() : w.addEventListener('load', ld); }
  w.addEventListener('pageshow', function (e) { if (e.persisted) end(); });
  n = w.performance && w.performance.now ? w.performance.now() : 0;
  if ((w.Shopify && w.Shopify.designMode) || !s || !w.IntersectionObserver || n > 2800 ||
    c.contains('gb-offer-over') || (w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches)) return end();
  io = new w.IntersectionObserver(function (a) { V = a[a.length - 1].isIntersecting; go(); }, { threshold: 0.5 });
  io.observe(s);
  cap = Math.min(2000, Math.max(200, 2500 - n));
  T.push(setTimeout(beat, cap));
  L = setTimeout(end, cap + 600);
  if (d.fonts && d.fonts.ready) d.fonts.ready.then(st, st);
  else st();
})(window, document);
